import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PosicionesEtapaTorneo from "../../tablas/PosicionesEtapaTorneo.js";
import MensajeCargando from "../../UI/MensajeCargando.js";
import MensajeError from "../../UI/MensajeError.js";
import useGetListaURL from "../../../hooks/useGetListaURL.js";
import * as Funciones from "../../funciones/FuncionesTorneos.js";

const PosicionesTorneo = (props) => {
  const datosElegidos = props.datosElegidos;
  const [posiciones, setPosiciones] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  const url = Funciones.URLPosicionesTorneo(datosElegidos);

  useEffect(() => {
    if (url) {
      fetchData(url, setPosiciones);
    } else {
      setPosiciones([]);
    }
  }, [url, fetchData]);

  const navigate = useNavigate();
  const onEquipoElegido = (idEquipo) => {
    navigate("/torneo/" + datosElegidos.torneo.id + "/equipo/" + idEquipo, { state: { datosElegidos } });
  };

  return (
    <React.Fragment>
      {!isCargando && posiciones && posiciones.length > 0 && (
        <PosicionesEtapaTorneo
          torneo={datosElegidos.torneo}
          posiciones={posiciones}
          onEquipoElegido={onEquipoElegido}
        />
      )}
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default PosicionesTorneo;
